import React from 'react';
import Header4 from './../Common/Header4';
import Footer from './../Common/Footer';
import Banner from './../Elements/Banner';
import GoogleMapReact from 'google-map-react';

var bnrimg = require('./../../images/contact-us/Contact-Us-1.png');

const AnyReactComponent = ({ text }) => <div>{text}</div>;

class ContactUs extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            username: '',
            email: '',
            phone: '',
            services: '',
            message: ''
        };
    }

    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    };

    handleSubmit = (e) => {
        e.preventDefault();

        const ukPhoneRegex = /^(\+44\s?7\d{3}|\(?07\d{3}\)?)\s?\d{3}\s?\d{3}$/;

        if (!ukPhoneRegex.test(this.state.phone)) {
            alert("Please enter a valid UK phone number.");
            return;
        }

        const formData = new FormData();
        formData.append("entry.923147120", this.state.username);
        formData.append("entry.344577380", this.state.email);
        formData.append("entry.1788403116", this.state.phone);
        formData.append("entry.514029235", this.state.services);
        formData.append("entry.1226737770", this.state.message);

        const googleFormUrl = "https://docs.google.com/forms/d/e/1FAIpQLScanxewnE6bPrG0YC1_plTkkLPjqZK48cZ1ktZIEbz7YmO2dA/formResponse";

        fetch(googleFormUrl, {
            method: "POST",
            mode: "no-cors",
            body: formData,
        })
            .then(() => {
                alert("Form submitted successfully!");
                this.setState({
                    username: "",
                    email: "",
                    phone: "",
                    services: "",
                    message: "",
                });
            })
            .catch((error) => {
                console.error("Error submitting form:", error);
                alert("There was an error submitting the form. Please try again.");
            });
    };

    render() {
        const defaultProps = {
            center: {
                lat: 51.5519753, lng: -0.448896
            },
            zoom: 16
        };
        return (
            <>
                <Header4 />
                <div className="page-content">
                    <Banner title="Putting a plan to action, to assure your satisfaction!" pagename="Contact Us" bgimage={bnrimg} />

                    {/* SECTION CONTENTG START */}
                    <div className="section-full p-tb80 inner-page-padding">
                        {/* LOCATION BLOCK*/}
                        <div className="container">
                            {/* GOOGLE MAP & CONTACT FORM */}
                            <div className="section-content">
                                {/* CONTACT FORM */}
                                <div className="row">
                                    <div className="col-md-8 col-sm-6">
                                        <form className="contact-form cons-contact-form" onSubmit={this.handleSubmit}>
                                            <div className="contact-one m-b30">
                                                {/* TITLE START */}
                                                <div className="section-head">
                                                    <div className="mt-separator-outer separator-left">
                                                        <div className="mt-separator">
                                                            <h2 className="text-uppercase sep-line-one "><span className="font-weight-300 text-primary">Get</span> In touch</h2>
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* TITLE END */}
                                                <div className="form-group">
                                                    <input
                                                        name="username"
                                                        type="text"
                                                        required
                                                        className="form-control"
                                                        placeholder="Name"
                                                        value={this.state.username}
                                                        onChange={this.handleChange}
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <input
                                                        name="email"
                                                        type="text"
                                                        className="form-control"
                                                        required
                                                        placeholder="Email"
                                                        value={this.state.email}
                                                        onChange={this.handleChange}
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <input
                                                        name="phone"
                                                        type="tel"
                                                        required
                                                        className="form-control"
                                                        placeholder="Phone Number"
                                                        value={this.state.phone}
                                                        onChange={this.handleChange}
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <select
                                                        name="services"
                                                        className="form-control"
                                                        required
                                                        style={{ color: 'black' }}
                                                        value={this.state.services}
                                                        onChange={this.handleChange}
                                                    >
                                                        <option value="" disabled style={{ color: 'black' }}>Select a Service</option>
                                                        <option value="Bedrooms">Bedrooms</option>
                                                        <option value="Doors">Doors</option>
                                                        <option value="Media Wall">Media Wall</option>
                                                        <option value="Wardrobes">Wardrobes</option>
                                                        <option value="Bookshelves">Bookshelves</option>
                                                        <option value="Storage Units">Storage Units</option>
                                                        <option value="Study">Study</option>
                                                        <option value="Kitchen">Kitchen</option>
                                                    </select>
                                                </div>
                                                <div className="form-group">
                                                    <textarea
                                                        name="message"
                                                        rows={4}
                                                        className="form-control"
                                                        required
                                                        placeholder="Message"
                                                        value={this.state.message}
                                                        onChange={this.handleChange}
                                                    />
                                                </div>
                                                <div className="text-right">
                                                    <button name="submit" type="submit" value="Submit" className="site-button btn-effect">submit</button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                    <div className="col-md-4 col-sm-6">
                                        <div className="contact-info m-b30">
                                            {/* TITLE START */}
                                            <div className="section-head">
                                                <div className="mt-separator-outer separator-left">
                                                    <div className="mt-separator">
                                                        <h2 className="text-uppercase sep-line-one "><span className="font-weight-300 text-primary">Contact</span> Info</h2>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* TITLE END */}
                                            <div className="bg-dark p-a20 text-white">
                                                <div className="mt-icon-box-wraper left p-b40">
                                                    <div className="icon-xs"><i className="fa fa-phone" /></div>
                                                    <div className="icon-content">
                                                        <h5 className="m-t0 font-weight-500">Phone number</h5>
                                                        <p>07836266666</p>
                                                        <p>01895771111</p>
                                                    </div>
                                                </div>
                                                <div className="mt-icon-box-wraper left p-b40">
                                                    <div className="icon-xs"><i className="fa fa-envelope" /></div>
                                                    <div className="icon-content">
                                                        <h5 className="m-t0 font-weight-500">Email address</h5>
                                                        <p>ennlivinginteriorsltd@gmail.com</p>
                                                    </div>
                                                </div>
                                                <div className="mt-icon-box-wraper left">
                                                    <div className="icon-xs"><i className="fa fa-map-marker" /></div>
                                                    <div className="icon-content">
                                                        <h5 className="m-t0 font-weight-500">Address info</h5>
                                                        <p>337 Long Lane, Hillingdon, Uxbridge, UB10 9JU, United Kingdom</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="gmap-outline">
                            <div style={{ height: '400px', width: '100%' }}>
                                <iframe
                                    width="100%"
                                    height="450"
                                    frameBorder="0"
                                    style={{ border: 0 }}
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2480.8865873401414!2d-0.45147092433943853!3d51.55197860744691!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48766dca0c22ea43%3A0x8c11bb6b98274ccb!2s337%20Long%20Ln%2C%20Uxbridge%20UB10%209JU%2C%20UK!5e0!3m2!1sen!2sin!4v1745156792583!5m2!1sen!2sin"
                                    allowFullScreen
                                ></iframe>
                            </div>
                        </div>
                    </div>
                    {/* SECTION CONTENT END */}
                </div>

                <Footer />
            </>
        );
    }
}

export default ContactUs;